import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';

import branch from 'client/core/branch';
import { SCREEN_ID_SEARCH_FILTERS } from 'client/constants/screenIds';
import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';

import Navbar from 'client/components/Navbar';
import NavbarButton from 'client/components/NavbarButton';
import SrSearchFilterForm from 'client/components/SrSearchFilterForm';

import filterListItems from 'client/helpers/filterListItems';

import AgentActions from 'client/actions/Agent';

@withTransitionHook
@withScreenId(SCREEN_ID_SEARCH_FILTERS)
@withScrollToTop
@branch({
  viewingRenterSearchFilters: ['agentMapView', 'viewingRenterSearchFilters'],
})
class AgentSearchFilterPage extends Component {
  static fetchData(match, inject) {
    const agentUserId = match.params.agentUserId
      ? parseInt(match.params.agentUserId, 10)
      : inject.state.get(['currentUser', 'id']);

    return AgentActions.getAgentTours(inject, { agentUserId }).then(() =>
      AgentActions.setViewingTour(inject, parseInt(match.params.tourId, 10)),
    );
  }

  static getPageMetadata = () => ({
    pageTitle: 'Filter Search | Sunroom Rentals',
    section: 'Onboarding',
    // canonical: '/',
    keywords: 'rent, home, apartment, austin, texas, tour',
    description:
      'Find a safe home in the right location with plenty of natural light! Plus a backyard for your pup 🐶',
  });

  static propTypes = {
    viewingRenterSearchFilters: PropTypes.object.isRequired,
  };

  _onSubmitFilter = (value) => {
    const { history, dispatch, match } = this.props;

    dispatch(AgentActions.updateViewingRenterSearchFilters, {
      filterKey: match.params.filterName,
      filterValue: value,
    });

    history.push(`/agent/${match.params.tourId}/search`);
  };

  render() {
    const { viewingRenterSearchFilters, match, history } = this.props;

    const filterData = filterListItems[match.params.filterName] || {};

    if (!filterData.id) {
      return <Redirect to={`/agent/${match.params.tourId}/search`} />;
    }

    return (
      <div className="modal specificFilter">
        <div className={filterData.type + ' ' + filterData.id}>
          <div className="modal filters specificFilter">
            <Navbar
              redirectLogoTo="/agent/tours"
              leftButton={
                <NavbarButton onClick={() => history.push(`/agent/${match.params.tourId}/search`)}>
                  Cancel
                </NavbarButton>
              }
            />

            <SrSearchFilterForm
              searchFilters={viewingRenterSearchFilters}
              onSubmit={this._onSubmitFilter}
              history={history}
              {...filterData}
            />
          </div>
        </div>
      </div>
    );
  }
}

AgentSearchFilterPage.displayName = 'AgentSearchFilterPage';

export default AgentSearchFilterPage;
